import React, { useEffect, useRef, useState } from "react";
import "./appointmentsViewTableCell.scss";
import { ClickAwayListener, IconButton } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import TitleSubtitleCard from "../Modules/TitleSubtitleCard";
import viewDocuments from "../../../assets/view-documents.svg";
import consultationIcon from "../../../assets/purpose_of_consultation.svg";
import callIcon from "../../../assets/dashboard/call_icon.svg";
import abhaTreeIcon from "../../../assets/abhaPageAssets/abha-tree-icon.png";
import info_icon from "../../../assets/dashboard/info_icon.svg";
import walk_in_icon from "../../../assets/dashboard/walk_in_icon.svg";
import editIcon from "../../../assets/edit-prescription.svg";
import disableCallIcon from "../../../assets/followUpCallGrey.svg";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import moment from "moment";
import ReceiptLoader from "../../UI Component/Loader/Loader";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ScheduleFollowUpModal } from "../scheduleFollowUpModal/ScheduleFollowUpModal";
import {
  APPLICABLE_ROLE,
  CONSULTATIONTYPE,
  HEADERLIST,
  STATUS,
} from "../../DashboardAppointmentsView/Constant";
import CallModal from "../../DoctorDashboard/CallModal";
import AppointmentJoinModal from "../../DoctorDashboard/modal-appointment-join";
import RescheduleModal from "../../DoctorDashboard/modal-reschedule";
import MarkNoShowModal from "../../DoctorDashboard/modal-mark-noshow";
import ViewDetailsModalNew from "../../common/ViewDetailsModal";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { viewFollowUpDate } from "../../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler";
import { getConsultationTypeDetail } from "../../DashboardAppointmentsView/Helper";
import {
  CALL_NEXT_APPOINTMENT_API,
  CHECK_IN_PROGRESS_APPOINTMENT_API,
  CLOSE_MEETING_API,
  CREATE_CRON_SCHEDULE,
  END_CONSULTATION_API,
  GET_APPOINTMENT_JOURNEY_API,
  MARK_CHECK_IN_API,
  START_CONSULTATION_API,
} from "../../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler/APIConstants";
import DocumentContainer from "../../UI Component/DocumentViewer/DocumentCotainer";
import ClinicShareReceiptModal from "../../ClinicComponents/ClinicMyAppointments/ClinicShareReceiptModal";
import PEMShareContentPopUp from "../../PEM";
import Popup from "../../PEM/common/Popup";
import swal from "sweetalert";
import {
  filteredOptions,
  ACTION_TYPES,
  APPLICABLE_STATUS,
  APPLICABLE_TYPE,
} from "../../DashboardAppointmentsView/Helper/actionsHelper";
import TitleValueComponent from "../Modules/TitleValueComponent";
import AlertMsgPopup from "../AlertMsgPopup/index";
import WaitingTimeComponent from "./waitingTimeComponent";
import VitalsModal from "../VitalsModal";
import DrawerComponent from "../../DrawerComponent";
import ERXViewContainer from "../../ERXViewContainer";
import CancelAppointmentPopup from "../CancelAppointmentPopup";
import RaiseInvoice from "../../RaiseInvoice";
import ScheduleFollowUpNewModal from "../ScheduleFollowUpNewModel";
import { USER_ROLE } from "../../../Util/constants";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import PhysicalConsultationModal from "../../PhysicalConsultation";
import { DEV, QA } from "../config";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import PrintRxTemplate from "../../PrintRxTemplate";

const AppointmentsViewTableCell = (props) => {
  const {
    arr,
    selected_doctor,
    user_type,
    doctorRole,
    user_id,
    clinic_id,
    staff_id,
    page_no,
    app_start_date,
    checkedInAppnt,
    doctorClinicAssociation,
    myPatients,
    refreshAppointmentsMethod,
    onRescheduleAppnt,
    callNextAppointmentWidget,
    appointmentsApi,
    setShowModalForScheduleFollowUp,
    showModalForScheduleFollowUp,
    isUhidEnabled,
  } = props;

  const history = useHistory();
  const location = useLocation();
  const [appointmentsData, setAppointmentsData] = useState([]);
  const [showCallPatientModal, setShowCallPatientModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showJoinAppointmentModal, setShowJoinAppointmentModal] =
    useState(false);
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const [showRaiseInvoiceModal, setRaiseInvoiceModal] = useState(false);
  const [showMarkNoShowModal, setShowMarkNoShowModal] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [appointmentForDrawer, setAppointmentForDrawer] = useState({});
  const [slugUrl, setSlugUrl] = useState();
  const [appointment, setAppointment] = useState();
  const [documentShow, setDocumentShow] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [showReceiptModal, setshowReceiptModal] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [showPEMShare, setshowPEMShare] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [receiptLoader, setReceiptLoader] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState();
  const [appointmentJourney, setAppointmentJourney] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openVitalsModal, setOpenVitalsModal] = useState(false);
  const [vitalModalTitle, setVitalModalTitle] = useState("");
  const cellRef = useRef();
  const rowRef = useRef();
  const [erxComponentOpen, setErxComponentOpen] = useState(false);
  const [followUpData, setFollowUpData] = useState();
  const [showPhysicalConsultationModal, setShowPhysicalConsultationModal] =
    useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [alertMsgPop, setAlertMsgPop] = useState("");
  const [editUhid, setEditUhid] = useState(false);
  const [showPrintRxTemplate, setShowPrintRxTemplate] = useState(false);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const doctorAssociatedToClinic = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const enableCallIcon = localStorage.getItem(
    LOCALSTORAGEKEY.ENABLE_CALL_APPOINTMENT_PATIENTS
  );

  const actionClickHandlers = [
    {
      type: ACTION_TYPES.START_CONSULTATION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        checkForInProgressAppnt(appnt, startConsultationApi);
      },
    },
    {
      type: ACTION_TYPES.END_CONSULTATION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        endConsultationApi(appnt);
      },
    },
    {
      type: ACTION_TYPES.CALL_NEXT,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        callNextApi(appnt);
      },
    },
    {
      type: ACTION_TYPES.MARK_CHECK_IN,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        markCheckInApi(appnt);
      },
    },
    {
      type: ACTION_TYPES.MARK_NO_SHOW,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setShowMarkNoShowModal(true);
      },
    },
    {
      type: ACTION_TYPES.ADD_VITALS,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setOpenVitalsModal(true);
        setVitalModalTitle("Add");
      },
    },
    {
      type: ACTION_TYPES.EDIT_VITALS,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setOpenVitalsModal(true);
        setVitalModalTitle("Edit");
      },
    },
    {
      type: ACTION_TYPES.VIEW_VITALS,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setOpenVitalsModal(true);
        setVitalModalTitle("View");
      },
    },
    {
      type: ACTION_TYPES.JOIN_CALL,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        if (appnt.appointment_status === APPLICABLE_STATUS.IN_PROGRESS) {
          joinVideoCall(appnt);
        } else {
          checkForInProgressAppnt(appnt, checkJoinAlert);
        }
      },
    },
    {
      type: ACTION_TYPES.RESCHEDULE,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        selected_doctor.map((data) => {
          if (data.doctor_id === appnt.doctor_id) {
            setSlugUrl(data.short_url_slug);
          }
        });
        setShowRescheduleModal(true);
      },
    },
    {
      type: ACTION_TYPES.CANCEL,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setShowCancellationModal(true);
      },
    },
    {
      type: ACTION_TYPES.RAISE_INVOICE,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        // setRaiseInvoiceModal(true);
        handleRaiseInvoice(appnt);
      },
    },
    {
      type: ACTION_TYPES.CREATE_PRESCRIPTION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        editPrescription(
          appnt,
          user_type === APPLICABLE_ROLE.DOCTOR
            ? ACTION_TYPES.CREATE_PRESCRIPTION
            : ACTION_TYPES.UPLOAD_PRESCRIPTION
        );
      },
    },
    {
      type: ACTION_TYPES.EDIT_PRESCRIPTION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        editPrescription(
          appnt,
          user_type === APPLICABLE_ROLE.DOCTOR
            ? ACTION_TYPES.EDIT_PRESCRIPTION
            : ACTION_TYPES.MANAGE_PRESCRIPTION
        );
      },
    },
    {
      type: ACTION_TYPES.VIEW_PRESCRIPTION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        viewPrescription(appnt);
      },
    },
    {
      type: ACTION_TYPES.PRINT_RX_TEMPLATE,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        setShowPrintRxTemplate(true);
      },
    },
    {
      type: ACTION_TYPES.EDIT_RECEIPT,
      clickHandler: (appnt) => {
        handleClose(appnt);
        appnt.edit_receipt = true;
        setAppointment(appnt);
        // setRaiseInvoiceModal(true);
        handleRaiseInvoice(appnt);
      },
    },
    {
      type: ACTION_TYPES.SHARE_RECEIPT,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        shareReceipt(appnt);
      },
    },
    {
      type: ACTION_TYPES.VIEW_RECEIPT,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        viewReceipt(appnt);
      },
    },
    {
      type: ACTION_TYPES.SHARE_PATIENT_EDUCATION,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setshowPEMShare(true);
      },
    },
    {
      type: ACTION_TYPES.VIEW_DETAILS,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        viewDetailsApi(appnt);
      },
    },
    {
      type: ACTION_TYPES.VIEW_DOCUMENTS,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setAppointmentForDrawer({
          app_id: { id: appnt.appointment_id },
          doctor_id: appnt?.doctor_id,
        });
        setDrawerOpen(true);
        setDrawerType(ACTION_TYPES.VIEW_DOCUMENTS);
      },
    },
    {
      type: ACTION_TYPES.END_AND_SCHEDULE_FOLLOW_UP,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setLoading(true);
        endConsultationApiAndFollowUp(appnt);
      },
    },
    {
      type: ACTION_TYPES.SCHEDULE_FOLLOW_UP,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        scheduleFollowUp(appnt);
      },
    },
    {
      type: ACTION_TYPES.ADD_BOOKING,
      clickHandler: (appnt) => {
        handleClose(appnt);
        setAppointment(appnt);
        setShowPhysicalConsultationModal(true);
      },
    },
  ];

  // Lifecycle methods ==>

  useEffect(() => {
    setAppointmentsData(props.appointmentsData);
  }, [props.appointmentsData]);
  // <===

  // Helper methods ==>

  const getClassName = () => {
    let name = "col-md-3";
    if (
      !myPatients &&
      (user_type === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN)
    ) {
      name = "col-md-2";
    }
    return name;
  };

  const getDoctorDatetimeClassName = () => {
    let name = "col-md-2";
    if (myPatients) {
      name = "col-md-3";
    }
    return name;
  };

  const getActionClassName = () => {
    let name = "";
    if (!myPatients) {
      if (
        user_type !== APPLICABLE_ROLE.STAFF &&
        doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
        doctorRole !== USER_ROLE.RESOURCE_ADMIN
      ) {
        name = "col-md-2 justify-content-end p-0";
      }
    } else {
      name = "col-md-1 p-0";
    }
    return name;
  };

  const getTitleStyle = (appnt) => {
    let style = {};
    STATUS.forEach((st) => {
      if (st.name === appnt.appointment_status.toLowerCase()) {
        style = {
          color: st.color,
          backgroundColor: st.backgroundColor,
          border: "1px solid " + st.color,
        };
      }
    });
    return style;
  };

  const getHoverText = (appnt) => {
    return (
      <span>
        Patient has uploaded{" "}
        <b>
          {appnt.patient_uploaded_doc_count}{" "}
          {appnt.patient_uploaded_doc_count > 1 ? "Documents" : "Document"}
        </b>
      </span>
    );
  };

  const getConsultationTitle = (appnt) => {
    let consultationName =
      appnt.account_type == 1 ? appnt.procedure_name : appnt.appointment_type;

    if (
      appnt.is_lims_booking &&
      appnt.procedure_count &&
      appnt.procedure_count - 1 > 0
    ) {
      consultationName = (
        <div style={{ display: "block" }}>
          {consultationName}
          <span
            className="appointments-view-table-cell-multiple-procedures"
            onClick={() => handleMultipleProceduresPopup(appnt)}
          >
            +{appnt.procedure_count - 1}
          </span>
        </div>
      );
    }

    return consultationName;
  };

  const getConsultationSubtitle = (appnt) => {
    let duration =
      (appnt.account_type === 1 ? "" : " ") + "(" + appnt.slot_duration + ") ";
    return (
      <>
        {appnt.account_type !== 1 && (
          <>
            {appnt.consultation_type.toLowerCase() ===
            CONSULTATIONTYPE.PROCEDURE
              ? appnt.procedure_name
              : appnt.consultation_type}
          </>
        )}{" "}
        {duration}
      </>
    );
  };

  // <===

  // Actions ==>

  function checkJoinAlert(appnt) {
    afterLoginApiAxios
      .post(
        "/user/check-joining-alert",
        {
          meeting_id: appnt?.appointment_id
            ? appnt?.appointment_id
            : appointment?.appointment_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data?.statusCode === 200) {
            if (
              response.data?.data?.show_pop_up &&
              ((appnt?.appointment_status &&
                appnt?.appointment_status === "confirmed") ||
                (appointment?.appointment_status &&
                  appointment?.appointment_status === "confirmed"))
            ) {
              setShowJoinAppointmentModal(true);
            } else {
              joinVideoCall(appnt);
            }
          } else {
            // TODO: Error handling and logging
            joinVideoCall(appnt);
          }
        } else {
          joinVideoCall(appnt);
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  const closeOngoingConsultation = (data) => {
    // Call API to close ongoing consultation
    let payload = {
      doctor_id: userId,
      appointment_id: data?.appointment_id,
    };
    let result = c2cPostApiHandler(CLOSE_MEETING_API, payload);

    result
      .then((response) => {
        C2CConsole.log(response);
        setLoading(false);
      })
      .catch((err) => C2CConsole.log(err));
  };

  function joinVideoCall(appnt) {
    let appt = appnt ? appnt : appointment;
    let app_id = {
      // this is required as video component requires these properties
      // TODO: to be optimized once video render logic is rewritten
      id: appt?.appointment_id,
      patient_id: appt?.patient_id,
      patient_account_id: appt?.patient_account_id,
      patient_name: appt?.patient_name,
      patient_dob: appt?.patient_dob,
      phone_no: appt?.patient_phone_no,
      patient_gender: appt?.patient_gender,
      patient_city: appt?.patient_city,
      first_name: appt?.first_name,
      last_name: appt?.last_name,
      degree: appt?.degree,
      appointment_date: appt?.appointment_date,
      appointment_end_date_time:
        appt?.appointment_date + " " + appt?.appointment_end_time,
      appointment_start_date_time: appt?.appointment_date_and_time,
      start_time: appt?.appointment_start_time,
      end_time: appt?.appointment_end_time,
      doctor_id: appt?.doctor_id,
      in_progress:
        appt?.appointment_status === APPLICABLE_STATUS.IN_PROGRESS
          ? true
          : false,
    };

    history.push({
      pathname:
        doctorClinicAssociation === "true" ? "/clinic/video" : "/doctor/video",
      state: {
        app_id: app_id,
        is_audio: true,
        is_video: true,
      },
    });
  }

  function handleDrawerToggle() {
    setDrawerOpen(false);
    setLoading(false);
    if (myPatients) {
      appointmentsApi();
    } else {
      if (app_start_date !== moment().format("YYYY-MM-DD")) {
        appointmentsApi();
      }
    }
  }

  const handleMenuClick = (appnt) => {
    let index = appointmentsData.findIndex(
      (data) => data.appointment_id === appnt.appointment_id
    );
    appointmentsData[index].openActionMenu =
      !appointmentsData[index].openActionMenu;
    setAppointmentsData([...appointmentsData]);
  };

  const handleERXComponentClose = () => {
    setLoading(false);
    setErxComponentOpen(false);
    if (myPatients) {
      appointmentsApi();
    } else {
      if (app_start_date !== moment().format("YYYY-MM-DD")) {
        appointmentsApi();
      }
    }
  };

  const handleClosePrintRxPopup = () => {
    setShowPrintRxTemplate(false);
    setLoading(false);
  };

  const handleClose = (appnt) => {
    let index = appointmentsData.findIndex(
      (data) => data.appointment_id === appnt.appointment_id
    );
    appointmentsData[index].openActionMenu = false;
    setAppointmentsData([...appointmentsData]);
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileURL: "",
      fileName: "Invoice for Your Connect2Clinic appointment",
      fileType: ".pdf",
    });
  };

  const editPrescription = (appnt, type) => {
    let tempDate = new Date();
    let yr = tempDate.getFullYear();
    let age = yr - Number(appnt?.patient_dob?.substring(0, 4));

    setAppointmentForDrawer({
      app_id: {
        id: appnt?.appointment_id,
        patient_gender: appnt?.patient_gender,
      },
      expiryTime: appnt?.appointment_journey_time?.booked?.booking_time,
      ageForDrawer: age,
      patientId: appnt?.patient_id,
      patientAccountId: appnt?.patient_account_id,
      patient_dob: appnt?.patient_dob,
      patient_name: appnt?.patient_name,
      patient_phone_no: appnt?.patient_phone_no,
      doctor_id: appnt?.doctor_id,
      appointment_consultation_type: appnt?.appointment_consultation_type,
    });

    if (
      user_type === APPLICABLE_ROLE.DOCTOR &&
      appnt?.appointment_type.toLowerCase() === APPLICABLE_TYPE.INCLINIC
    ) {
      setErxComponentOpen(true);
    } else {
      setDrawerOpen(true);
    }
    setDrawerType(type);
  };

  const viewPrescription = (appnt) => {
    history.replace(`${location.pathname}`);
    history.push({
      pathname: "/prescription/" + appnt.appointment_id,
      state: {
        pageNumber: page_no,
      },
    });
  };

  const pemCloseBtnCallback = (closeBtnState = false) => {
    setLoading(false);
    setshowPEMShare(false);
    if (!closeBtnState) {
      setShowPopUp(true);
    }
  };

  const handleActionSelected = (appnt, item) => {
    actionClickHandlers.forEach((ac) => {
      if (item.type === ac.type) {
        ac.clickHandler(appnt);
      }
    });
  };

  const handleCloseAlertPopup = () => {
    setOpenAlert(false);
  };

  const handleActionScroll = (scrollTo, index, appnt) => {
    const content = document.getElementById(`action_id${index}`);
    let indx = appointmentsData.findIndex(
      (el) => el.appointment_id === appnt.appointment_id
    );
    if (scrollTo === "right") {
      appointmentsData[indx].actionScroll = true;
      content.scrollLeft = content.scrollWidth;
    } else {
      appointmentsData[indx].actionScroll = false;
      content.scrollLeft = 0;
    }

    setAppointmentsData([...appointmentsData]);
  };

  const handleCapturedTimeScroll = (scrollTo, index, appnt) => {
    const content = document.getElementById(`captured_time_id${index}`);
    let indx = appointmentsData.findIndex(
      (el) => el.appointment_id === appnt.appointment_id
    );
    if (scrollTo === "right") {
      appointmentsData[indx].capturedTimeScroll = true;
      content.scrollLeft = content.scrollWidth;
    } else {
      appointmentsData[indx].capturedTimeScroll = false;
      content.scrollLeft = 0;
    }

    setAppointmentsData([...appointmentsData]);
  };

  const showSetAppointmentType = (onlineAppointment) => {
    setShowAlertPopup(true);
    setTimeout(() => {
      setShowAlertPopup(false);
    }, 2000);
    if (onlineAppointment) {
      setAlertMsgPop("Link Shared Successfully");
    } else {
      setAlertMsgPop("Appointment Booked Successfully");
    }
  };

  const handleCloseEditUhid = () => {
    setEditUhid(false);
  };

  const handleRaiseInvoice = (appnt) => {
    let path = `${
      doctorAssociatedToClinic ? "/clinic" : "/doctor"
    }/account/raise-invoice`;
    history.push({
      pathname: path,
      state: {
        appointment_id: appnt?.appointment_id,
        edit_receipt: appnt?.edit_receipt,
        doctor_id: appnt?.doctor_id,
        dashboardRaiseInvoiceModal: true,
        order_id: appnt?.order_id ?? "",
        appointment: appnt,
        user_id: user_id,
        clinic_id: clinic_id,
        staff_id: staff_id,
        user_type: user_type,
      },
    });
  };

  const handleEditRaiseInvoice = (appnt) => {
    appnt.edit_receipt = true;
    setAppointment(appnt);
    handleRaiseInvoice(appnt);
  };

  // <===

  // API Calls ==>

  const checkForInProgressAppnt = (appnt, func) => {
    let data = {
      doctor_id: appnt?.doctor_id,
    };
    let result = c2cPostApiHandler(CHECK_IN_PROGRESS_APPOINTMENT_API, data);
    result.then(([response, error]) => {
      if (!error) {
        if (response.data && response.data.statusCode === 200) {
          // Check for ongoing appointment
          if (
            response.data.ongoing_appointment &&
            response?.data?.data?.appointment_id !== appnt?.appointment_id
          ) {
            response.data.data.consultation_type = getConsultationTypeDetail(
              response.data.data
            );
            closeOngoingAppnt(appnt, response.data.data);
          }
          // Check for upcoming scheduled appointment
          else if (response.data.upcoming_appointment) {
            handleUpcommingAppointment(appnt);
          } else if (
            clinic_id === response?.data?.data?.clinic_id &&
            response?.data?.data?.appointment_id !== appnt?.appointment_id
          ) {
            closeOngoingAppnt(appnt, response.data.data);
          } else {
            func(appnt);
          }
        }
      }
    });
  };

  const callNextApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      doctor_ids: [appnt.doctor_id],
      clinic_id: clinic_id,
    };

    let result = c2cPostApiHandler(CALL_NEXT_APPOINTMENT_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          myPatients && appointmentsApi();
          callNextAppointmentWidget && callNextAppointmentWidget();
          clinic_id && scheduleCronAPICall(appnt);
        }
        setLoading(false);
      }
      setLoading(false);
    });
  };

  const closeOngoingAppnt = (appnt, data) => {
    if (data?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      endConsultationApi(data);
    } else {
      closeOngoingConsultation(data);
    }
    if (appnt?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      startConsultationApi(appnt);
    } else {
      joinVideoCall(appnt);
    }
    setLoading(false);
  };

  const handleUpcommingAppointment = (appnt) => {
    if (appnt?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      startConsultationApi(appnt);
    } else {
      joinVideoCall(appnt);
    }
    setLoading(false);
  };

  const markCheckInApi = (appnt) => {
    let data = {
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
    };
    let result = c2cPostApiHandler(MARK_CHECK_IN_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setOpenAlert(true);
          setAlertMsg("Mark Checked In Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            myPatients && appointmentsApi();
            callNextAppointmentWidget && callNextAppointmentWidget();
            setLoading(false);
          }, 2000);
        } else {
          swal({
            title: "Sorry",
            text: res?.data?.message
              ? res?.data?.message
              : "Something Went Wrong. Please try again",
            icon: "warning",
          }).then(() => {
            //
          });
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const startConsultationApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };

    let result = c2cPostApiHandler(START_CONSULTATION_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setOpenAlert(true);
          setAlertMsg("Consultation Started Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            myPatients && appointmentsApi();
            callNextAppointmentWidget && callNextAppointmentWidget();
            setLoading(false);
          }, 2000);
        } else {
          swal({
            title: "Sorry",
            text: res?.data?.message
              ? res?.data?.message
              : "Something Went Wrong. Please try again",
            icon: "warning",
          }).then(() => {
            //
          });
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const endConsultationApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };

    let result = c2cPostApiHandler(END_CONSULTATION_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          clinic_id && scheduleCronAPICall(appnt);
          setOpenAlert(true);
          setAlertMsg("Consultation Ended Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            myPatients && appointmentsApi();
            callNextAppointmentWidget && callNextAppointmentWidget();
            setLoading(false);
          }, 2000);
        } else {
          swal({
            title: "Sorry",
            text: res?.data?.message
              ? res?.data?.message
              : "Something Went Wrong. Please try again",
            icon: "warning",
          }).then(() => {
            //
          });
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const scheduleFollowUp = async (appnt) => {
    const { res } = await viewFollowUpDate(appnt?.appointment_id);

    if (res) {
      setFollowUpData(res);
      setShowModalForScheduleFollowUp(true);
    }
  };

  const endConsultationApiAndFollowUp = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };

    let result = c2cPostApiHandler(END_CONSULTATION_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setLoading(false);
          clinic_id && scheduleCronAPICall(appnt);
          setOpenAlert(true);
          setAlertMsg("Consultation Ended Successfully");
          scheduleFollowUp(appnt);
          setTimeout(() => {
            handleCloseAlertPopup();
            myPatients && appointmentsApi();
            callNextAppointmentWidget && callNextAppointmentWidget();
          }, 2000);
        } else {
          swal({
            title: "Sorry",
            text: res?.data?.message
              ? res?.data?.message
              : "Something Went Wrong. Please try again",
            icon: "warning",
          }).then(() => {
            //
          });
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const handleMultipleProceduresPopup = (appnt) => {
    setAppointment(appnt);
    viewDetailsApi(appnt);
  };

  const viewDetailsApi = (appnt) => {
    setShowViewModal(true);
    let data = {
      appointment_id: appnt.appointment_id,
    };
    let details = c2cPostApiHandler(GET_APPOINTMENT_JOURNEY_API, data);
    details.then(([res, error]) => {
      if (!error) {
        if (res?.data) {
          setAppointmentJourney(res.data);
        }
      }
    });
    setLoading(false);
  };

  const shareReceipt = (appnt) => {
    let payload = {
      doctor_id: user_type === "staff" ? appnt.doctor_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      ...(appnt?.order_id && { order_id: appnt?.order_id }),
    };
    if (user_type === APPLICABLE_ROLE.STAFF) {
      payload = {
        ...payload,
        staff_id: staff_id,
      };
    }
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setshowReceiptModal(true);
          setTimeout(function () {
            setshowReceiptModal(false);
            myPatients && appointmentsApi();
          }, 2000);
        }
        setLoading(false);
      })
      .catch((err) => C2CConsole.log(err));
  };

  const viewReceipt = (appnt) => {
    setReceiptLoader(true);
    let payload = {
      doctor_id: appnt.doctor_id ? appnt.doctor_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      is_shared: "False",
      ...(appnt?.order_id && { order_id: appnt?.order_id }),
    };
    if (user_type === APPLICABLE_ROLE.STAFF) {
      payload = {
        ...payload,
        staff_id: staff_id,
      };
    }
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setReceiptLoader(false);
          setFileDetails({
            ...fileDetails,
            fileURL: response?.data?.invoice_link,
          });
          if (response?.data?.invoice_link !== "") {
            setDocumentShow(true);
          } else {
            swal({
              title: "Unable to generate receipt.",
              text: "Please try again",
              icon: "error",
              button: "Okay",
            });
            setDocumentShow(false);
          }
        } else {
          swal({
            title: "Unable to generate receipt.",
            text: "Please try again",
            icon: "error",
            button: "Okay",
          });
          setReceiptLoader(false);
          setDocumentShow(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setReceiptLoader(false);
        setDocumentShow(false);
        C2CConsole.log(err);
      });
  };

  const scheduleCronAPICall = (appnt) => {
    let data = {
      category: "feedback_time",
      appointment_id: appnt.appointment_id,
      clinic_id: clinic_id,
    };

    let result = c2cPostApiHandler(CREATE_CRON_SCHEDULE, data);
    result.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        console.log("scheduled cron");
      }
    });
  };

  const handleCallPatient = (appnt) => {
    setAppointment(appnt);
    setShowCallPatientModal(true);
  };

  const handleCloseVitalsModal = () => {
    setOpenVitalsModal(false);
    myPatients && appointmentsApi();
  };

  const handleEditUhid = (appnt) => {
    setEditUhid(true);
    setLoading(true);
    handleMultipleProceduresPopup(appnt);
  };

  const handleViewDetails = (appnt) => {
    setLoading(true);
    handleMultipleProceduresPopup(appnt);
  };

  // <===

  // Create UI ==>

  const getSubtitleIcon = () => {
    return !clinic_id || (clinic_id && enableCallIcon === "true")
      ? callIcon
      : disableCallIcon;
  };

  const uhidUI = (appnt) => {
    return (
      <>
        {clinic_id && (isUhidEnabled || appnt?.formatted_uhid) ? (
          <div className="uhid-section">
            <div className="subtitle-text uhid-heading">UHID:</div>
            <div className="subtitle-text uhid-content">
              {appnt?.formatted_uhid}
            </div>
            {appnt?.manual_uhid && isUhidEnabled && (
              <div className="uhid-icon-container">
                <img
                  className="uhid-edit-icon"
                  src={editIcon}
                  alt=""
                  onClick={() => handleEditUhid(appnt)}
                />
              </div>
            )}
          </div>
        ) : null}
      </>
    );
  };
  const checkPremiumSlot = (appnt) => {
    return appnt?.custom_booking ? (
      <>
        <span
          className="premium-slot-badge-icon"
          style={{ cursor: "pointer", marginLeft: "6px" }}
        >
          c
        </span>
      </>
    ) : null;
  };

  const displayData = () => {
    return (
      appointmentsData?.length > 0 && (
        <div>
          {appointmentsData.map((appnt, ind) => (
            <div
              className="dashboard-appointments-table-container"
              key={appnt.appointment_id}
            >
              <div
                className={
                  "dashboard-appointments-table-content " +
                  (window.innerWidth > 767 ? "d-flex pb-2" : "")
                }
              >
                {arr.includes(HEADERLIST.PATIENTDETAILS) && (
                  <span
                    className={
                      "Patient-details " +
                      (window.innerWidth > 767
                        ? getClassName() + " pl-0"
                        : "table-sub-container")
                    }
                  >
                    <span className="dashboard-table-title-mobile-view">
                      {HEADERLIST.PATIENTDETAILS}
                    </span>
                    <TitleSubtitleCard
                      title={appnt.patient_name}
                      subtitle={
                        appnt.masking === "True"
                          ? appnt.masked_patient_number
                          : appnt.patient_phone_no
                      }
                      uhId={() => uhidUI(appnt)}
                      subtitleRightIcon={
                        appnt.patient_uploaded_doc_count > 0 && viewDocuments
                      }
                      subtitleRightIconHoverText={
                        appnt.patient_uploaded_doc_count > 0 &&
                        getHoverText(appnt)
                      }
                      subtitleIcon={getSubtitleIcon()}
                      data={appnt}
                      disableSubtitleIcon={
                        clinic_id && enableCallIcon !== "true"
                      }
                      handleIconClick={handleCallPatient}
                      viewIcon={
                        appnt.purpose_of_appointment && consultationIcon
                      }
                      displayHoverText={appnt.purpose_of_appointment}
                      handleViewDetails={() => {
                        handleViewDetails(appnt);
                      }}
                    />
                  </span>
                )}
                {arr.includes(HEADERLIST.DOCTORNAME) && (
                  <span
                    className={
                      "Doctor-name " +
                      (window.innerWidth > 767
                        ? getDoctorDatetimeClassName()
                        : "table-sub-container")
                    }
                  >
                    <span className="dashboard-table-title-mobile-view">
                      {HEADERLIST.DOCTORNAME}
                    </span>
                    <span>{appnt.doctor_full_name}</span>
                  </span>
                )}
                {arr.includes(HEADERLIST.CONSULTATION) && (
                  <span
                    className={
                      "Consultation " +
                      (window.innerWidth > 767
                        ? "col-md-3 pl-2"
                        : "table-sub-container")
                    }
                  >
                    <span className="dashboard-table-title-mobile-view">
                      {HEADERLIST.CONSULTATION}
                    </span>
                    <TitleSubtitleCard
                      title={getConsultationTitle(appnt)}
                      titleIcon={
                        appnt?.is_walkin
                          ? walk_in_icon
                          : appnt?.custom_booking && checkPremiumSlot(appnt)
                      }
                      titleIconHoverText={
                        appnt?.is_walkin
                          ? "Walk In"
                          : appnt?.custom_booking && "Customised"
                      }
                      subtitle={getConsultationSubtitle(appnt)}
                      customIcon={!appnt?.is_walkin && appnt?.custom_booking}
                    />
                  </span>
                )}
                {arr.includes(HEADERLIST.STATUS) && (
                  <span
                    className={
                      "Status " +
                      (window.innerWidth > 767
                        ? "col-md-2"
                        : "table-sub-container")
                    }
                  >
                    <span className="dashboard-table-title-mobile-view">
                      {HEADERLIST.STATUS}
                    </span>
                    <TitleSubtitleCard
                      titleStyle={getTitleStyle(appnt)}
                      title={appnt.appointment_status}
                      subtitle={appnt.payment_method}
                    />
                  </span>
                )}
                {arr.includes(HEADERLIST.DATETIME) && (
                  <span
                    className={
                      "Date-time " +
                      (window.innerWidth > 767
                        ? getDoctorDatetimeClassName()
                        : "table-sub-container pb-2")
                    }
                  >
                    <div>
                      <span className="dashboard-table-title-mobile-view">
                        {HEADERLIST.DATETIME}
                      </span>
                      <TitleSubtitleCard
                        title={moment(appnt.appointment_date).format(
                          "MMM DD, YYYY"
                        )}
                        subtitle={moment(
                          appnt.appointment_start_time,
                          "hh:mm:ssZ"
                        ).format("hh:mm A")}
                      />
                    </div>
                  </span>
                )}

                {(process.env.REACT_APP_ENV === DEV ||
                  process.env.REACT_APP_ENV === QA ||
                  window.location.hostname === "localhost") && (
                  <div
                    className={"Status table-sub-container abha-indicator-icon"}
                  >
                    {window.innerWidth < 767 &&
                      clinic_id &&
                      appnt?.is_abha_docs &&
                      doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
                      doctorRole !== USER_ROLE.RESOURCE_CONSULTANT && (
                        <img src={abhaTreeIcon} alt="#" />
                      )}
                  </div>
                )}

                <div
                  className={
                    "d-flex align-items-center " + getActionClassName()
                  }
                  ref={cellRef}
                >
                  {window.innerWidth > 767 && (
                    <span
                      className={
                        "d-flex align-items-center " + getActionClassName()
                      }
                    >
                      <div style={{ position: "relative" }}>
                        <IconButton
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          className={`${loading ? "menu_icon" : ""}`}
                          onClick={() => handleMenuClick(appnt)}
                        >
                          <MoreHorizIcon style={{ color: "#000" }} />
                        </IconButton>
                        {appnt.openActionMenu && displayActionsMenu(appnt)}
                      </div>
                    </span>
                  )}
                  {(process.env.REACT_APP_ENV === DEV ||
                    process.env.REACT_APP_ENV === QA ||
                    window.location.hostname === "localhost") && (
                    <div
                      className={
                        "abha-indicator-box " +
                        (myPatients && "my-patient-abha-indicator")
                      }
                    >
                      {window.innerWidth > 767 &&
                        clinic_id &&
                        appnt?.is_abha_docs &&
                        doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
                        doctorRole !== USER_ROLE.RESOURCE_CONSULTANT && (
                          <img src={abhaTreeIcon} alt="#" />
                        )}
                    </div>
                  )}
                </div>
              </div>

              {displayCapturedTime(appnt, ind)}
              {window.innerWidth < 767 && (
                <div className="pl-0 pr-0 col-12 d-flex flex-row justify-content-between action-buttons-mobile-view">
                  {displayActionsMenuMobileView(appnt, ind)}
                </div>
              )}
            </div>
          ))}
        </div>
      )
    );
  };

  const displayPartialAndPending = (appnt, show_border) => {
    return (
      <div>
        {appnt?.appointment_type === CONSULTATIONTYPE.INCLINIC &&
          clinic_id &&
          appnt.appointment_status !== "No show" &&
          !appnt.appointment_status.toLowerCase().includes("cancelled") &&
          appnt?.partial_payment_filter && (
            <>
              {show_border && (
                <hr style={{ borderStyle: "dashed", margin: "0" }} />
              )}
              <div
                className="partial-view"
                style={{ padding: show_border ? "0.5rem 0px" : "" }}
              >
                <TitleValueComponent
                  title="Partial"
                  value={" ₹ " + appnt?.partial_amount}
                />
                {window.innerWidth > 767 && (
                  <span className="slash-view">/</span>
                )}
                <TitleValueComponent
                  title={
                    <span
                      style={{
                        color:
                          appnt.appointment_status === "completed" &&
                          appnt?.pending_amount > 0
                            ? "#F82323"
                            : "",
                      }}
                    >
                      pending
                    </span>
                  }
                  value={
                    <span
                      style={{
                        color:
                          appnt.appointment_status === "completed" &&
                          appnt?.pending_amount > 0
                            ? "#F82323"
                            : "",
                      }}
                    >
                      {" ₹ " + appnt?.pending_amount}
                    </span>
                  }
                />
              </div>
            </>
          )}
      </div>
    );
  };

  const displayCapturedTime = (appnt, ind) => {
    let captured_time = appnt?.appointment_journey_time;

    return (
      <>
        {appnt?.captured_time?.length > 0 && (
          <div>
            <hr style={{ borderStyle: "dashed", margin: "0" }} />
            <div className="w-100 captured-time">
              {window.innerWidth < 767 &&
                appnt.captured_time.length > 3 &&
                appnt.capturedTimeScroll && (
                  <button
                    style={{ background: "rgba(255,255,255,0.7)" }}
                    onClick={() => handleCapturedTimeScroll("left", ind, appnt)}
                  >
                    <ArrowBackIosNewIcon />
                  </button>
                )}
              <div
                style={{
                  display: "flex",
                  overflowX: window.innerWidth < 767 ? "scroll" : "",
                  width: "100%",
                  padding: window.innerWidth < 767 ? "0.5rem" : "0.5rem 0",
                  alignItems: "center",
                }}
                id={`captured_time_id${ind}`}
              >
                {appnt.captured_time.map((time, indC) => (
                  <div key={indC} style={{ display: "contents" }}>
                    {time.checked_in_time && (
                      <div
                        className={
                          window.innerWidth > 767
                            ? ""
                            : "captured_time_mobile_view"
                        }
                        style={{ marginRight: "15px" }}
                      >
                        <TitleValueComponent
                          title="Checked In"
                          value={moment(time.checked_in_time).format("hh:mm A")}
                          icon={info_icon}
                          hoverText={"By " + time.checked_in_by}
                        />
                      </div>
                    )}
                    {time.waiting_time && (
                      <div
                        className={
                          window.innerWidth > 767
                            ? ""
                            : "captured_time_mobile_view"
                        }
                        style={{ marginRight: "15px" }}
                      >
                        <WaitingTimeComponent
                          captured_time={captured_time}
                          appnt={appnt}
                        />
                      </div>
                    )}
                    {time.consultation_started_time && (
                      <div
                        className={
                          window.innerWidth > 767
                            ? "consultaion_start"
                            : "captured_time_mobile_view"
                        }
                        style={{ marginRight: "15px" }}
                      >
                        <TitleValueComponent
                          title="Con. Started"
                          value={moment(time.consultation_started_time).format(
                            "hh:mm A"
                          )}
                          icon={info_icon}
                          hoverText={"By " + time.cconsultation_started_by}
                        />
                      </div>
                    )}
                    {time.consultation_ended_time && (
                      <div
                        className={
                          window.innerWidth > 767
                            ? "consultaion_end"
                            : "captured_time_mobile_view"
                        }
                        style={{ marginRight: "15px" }}
                      >
                        <TitleValueComponent
                          title="Con. Ended"
                          value={moment(time.consultation_ended_time).format(
                            "hh:mm A"
                          )}
                          icon={info_icon}
                          hoverText={"By " + time.consultation_ended_by}
                        />
                      </div>
                    )}

                    {time.no_show_time && ( // if greater than check in time and not of cancel time
                      <div
                        className={
                          window.innerWidth > 767
                            ? getClassName() + " pl-0"
                            : "captured_time_mobile_view"
                        }
                      >
                        <TitleValueComponent
                          title="No Show"
                          value={moment(time.no_show_time).format("hh:mm A")}
                          icon={info_icon}
                          hoverText={"By " + time.no_show_by}
                        />
                      </div>
                    )}
                    {time.cancelled_time && (
                      <div
                        className={
                          window.innerWidth > 767
                            ? getClassName() + " pl-0"
                            : "captured_time_mobile_view"
                        }
                      >
                        <TitleValueComponent
                          title="Cancelled"
                          value={moment(time.cancelled_time).format("hh:mm A")}
                          icon={info_icon}
                          hoverText={"By " + time.cancelled_by}
                        />
                      </div>
                    )}
                  </div>
                ))}

                {appnt.appointment_status === "completed" &&
                  appnt.follow_up_date !== null && (
                    <div
                      className={
                        window.innerWidth > 767
                          ? ""
                          : "captured_time_mobile_view"
                      }
                      style={{ marginRight: "15px" }}
                    >
                      <TitleValueComponent
                        title="Follow Up"
                        value={moment(appnt.follow_up_date).format(
                          "DD MMM, YYYY"
                        )}
                      />
                    </div>
                  )}

                {displayPartialAndPending(appnt)}
              </div>

              {window.innerWidth < 767 &&
                appnt.captured_time.length > 3 &&
                !appnt.capturedTimeScroll && (
                  <button
                    style={{ background: "rgba(255,255,255,0.7)" }}
                    onClick={() =>
                      handleCapturedTimeScroll("right", ind, appnt)
                    }
                  >
                    <ArrowForwardIosIcon />
                  </button>
                )}
            </div>
          </div>
        )}
        {!appnt?.captured_time?.length && (
          <>{displayPartialAndPending(appnt, "show_border")}</>
        )}
      </>
    );
  };

  const displayActionsMenuMobileView = (appnt, ind) => {
    let options = filteredOptions(appnt, user_type, user_id, checkedInAppnt);
    return (
      <div className="d-flex w-100" style={{ borderTop: "1px solid #d6dae5" }}>
        {options.length > 3 && appnt.actionScroll && (
          <button
            style={{ background: "rgba(255,255,255,0.7)" }}
            onClick={() => handleActionScroll("left", ind, appnt)}
          >
            <ArrowBackIosNewIcon />
          </button>
        )}
        <div
          style={{ display: "flex", overflowX: "scroll" }}
          id={`action_id${ind}`}
        >
          {options.map((item, index) => (
            <div key={index} className="action-buttons">
              {displayOptionItemsMobileView(item, appnt)}
            </div>
          ))}
        </div>
        {options.length > 3 && !appnt.actionScroll && (
          <button
            style={{ background: "rgba(255,255,255,0.7)" }}
            onClick={() => handleActionScroll("right", ind, appnt)}
          >
            <ArrowForwardIosIcon />
          </button>
        )}
      </div>
    );
  };

  const displayOptionItemsMobileView = (item, appnt) => {
    return (
      <button
        type="button"
        className="btn btn-default"
        data-tooltip={item.label}
        data-tooltip-conf="bottom"
        onClick={() => handleActionSelected(appnt, item)}
      >
        <img src={item.img} alt="" />
        <br />
        <small>{item.mobileLabel}</small>
        {item.expiryTime && displayExpiryTime(item.expiryTime)}
      </button>
    );
  };

  const displayActionsMenu = (appnt) => {
    let options = filteredOptions(appnt, user_type, user_id, checkedInAppnt);
    return (
      <ClickAwayListener onClickAway={() => handleClose(appnt)}>
        <div className="filter-menu-list transform-style-custom">
          <div className="dropdown">
            {options.map((item, index) => (
              <div key={index}>{displayOptionItems(item, appnt)}</div>
            ))}
          </div>
        </div>
      </ClickAwayListener>
    );
  };

  const displayOptionItems = (item, appnt) => {
    return (
      <div
        onClick={() => handleActionSelected(appnt, item)}
        className="filter-menu-list-item"
        style={{
          display: item.expiryTime ? "block" : "",
        }}
      >
        <span className="pl-2">{item.label}</span>
        {item.expiryTime && displayExpiryTime(item.expiryTime)}
      </div>
    );
  };

  const displayExpiryTime = (time) => {
    return (
      <div className="expiry-time-display">
        Expiring on {time.format("MMM DD, YYYY")} at {time.format("hh:mm a")}
      </div>
    );
  };

  const displayRestOfTheComponents = () => {
    return (
      <>
        <CallModal
          openView={showCallPatientModal}
          closeView={() => {
            setShowCallPatientModal(false);
          }}
          modalCloseView={() => {
            setShowCallPatientModal(false);
          }}
          appointment_id={appointment?.appointment_id}
          patientName={appointment?.patient_name}
        />
        <AppointmentJoinModal
          appointment={appointment}
          doctor_id={appointment?.doctor_id}
          openView={showJoinAppointmentModal}
          closeView={() => {
            setShowJoinAppointmentModal(false);
          }}
          joinVideoCallback={joinVideoCall}
        />
        {showRescheduleModal && (
          <RescheduleModal
            appointment={appointment}
            doctor_id={appointment?.doctor_id}
            user_id={user_id}
            openView={showRescheduleModal}
            closeView={() => {
              setShowRescheduleModal(false);
              setLoading(false);
            }}
            slugUrl={slugUrl}
            refreshAppointmentsMethod={() =>
              !myPatients
                ? onRescheduleAppnt(appointment?.appointment_id)
                : appointmentsApi()
            }
            callNextAppointmentWidget={callNextAppointmentWidget}
          />
        )}
        <CancelAppointmentPopup
          appointment_id={appointment?.appointment_id}
          appointment={appointment}
          handleEditRaiseInvoice={handleEditRaiseInvoice}
          doctorId={appointment?.doctor_id}
          openCancellationPopup={showCancellationModal}
          handleClosePopup={() => {
            setShowCancellationModal(false);
            setLoading(false);
          }}
          refreshAppointmentsMethod={refreshAppointmentsMethod}
          callNextAppointmentWidget={callNextAppointmentWidget}
        />
        {showRaiseInvoiceModal && (
          <RaiseInvoice
            appointment_id={appointment?.appointment_id}
            edit_receipt={appointment?.edit_receipt}
            openView={showRaiseInvoiceModal}
            closeView={() => {
              setRaiseInvoiceModal(false);
              setLoading(false);
            }}
            refreshAppointmentsMethod={refreshAppointmentsMethod}
            doctor_id={appointment?.doctor_id}
            dashboardRaiseInvoiceModal={true}
            order_id={appointment?.order_id ?? ""}
            appointment={appointment}
            user_id={user_id}
            clinic_id={clinic_id}
            staff_id={staff_id}
            user_type={user_type}
          />
        )}
        <MarkNoShowModal
          appointment_id={appointment?.appointment_id}
          openView={showMarkNoShowModal}
          closeView={() => {
            setShowMarkNoShowModal(false);
            setLoading(false);
          }}
          refreshAppointmentsMethod={refreshAppointmentsMethod}
          doctor_id={user_id}
          callNextAppointmentWidget={callNextAppointmentWidget}
        />

        <DrawerComponent
          appointmentDetails={appointment}
          drawerOpen={drawerOpen}
          toggleDrawer={handleDrawerToggle}
          drawerType={drawerType}
          appointmentForDrawer={appointmentForDrawer}
          fetchPastAppointmentDataList={refreshAppointmentsMethod}
        />
        <ViewDetailsModalNew
          openView={showViewModal}
          appointment={appointment}
          closeView={() => {
            setEditUhid(false);
            setShowViewModal(false);
          }}
          appointmentJourney={appointmentJourney}
          appointment_id={appointment?.appointment_id}
          masking={appointment?.masking}
          appointment_status={appointment?.appointment_status}
          editUhid={editUhid}
          handleCloseEditUhid={handleCloseEditUhid}
        />
        {documentShow && (
          <DocumentContainer
            cancelHandler={() => closeNotification()}
            url={fileDetails.fileURL}
            fileName={fileDetails.fileName}
            fileType={fileDetails.fileType}
            width={"98%"}
          />
        )}
        <ClinicShareReceiptModal show={showReceiptModal} />
        {showPEMShare && (
          <PEMShareContentPopUp
            patientId={appointment?.patient_id}
            appointment_id={appointment?.appointment_id}
            isERx={appointment?.prescription_notification_sent}
            pemCloseBtnCallback={pemCloseBtnCallback}
          />
        )}
        <Popup
          title={"Patient Education Content Shared!"}
          show={showPopUp}
          handleClose={() => setShowPopUp(false)}
        />
        {erxComponentOpen && (
          <ERXViewContainer
            drawerOpen={erxComponentOpen}
            setErxComponentOpen={(value) => {
              setLoading(false);
              setErxComponentOpen(value);
            }}
            drawerType={drawerType}
            appointmentData={appointment}
            toggleDrawer={handleERXComponentClose}
            refreshAppointmentsMethod={refreshAppointmentsMethod}
          />
        )}
        {showPrintRxTemplate && (
          <PrintRxTemplate
            appointmentData={appointment}
            handleClose={handleClosePrintRxPopup}
          />
        )}
        {openAlert && <AlertMsgPopup alertMsg={alertMsg} />}
        {openVitalsModal && (
          <VitalsModal
            title={vitalModalTitle}
            openModal={openVitalsModal}
            appointment_id={appointment?.appointment_id}
            patient_gender={appointment?.patient_gender}
            user_type={user_type}
            user_id={user_id}
            staff_id={staff_id}
            handleCloseModal={handleCloseVitalsModal}
          />
        )}

        {!clinic_id ? (
          <ScheduleFollowUpModal
            setShowModalForScheduleFollowUp={setShowModalForScheduleFollowUp}
            showModalForScheduleFollowUp={showModalForScheduleFollowUp}
            appointment={appointment}
            followUpData={followUpData}
            setOpenAlert={setOpenAlert}
            setAlertMsg={setAlertMsg}
            appointmentsApi={appointmentsApi}
          />
        ) : (
          <ScheduleFollowUpNewModal
            doctorRole={doctorRole}
            setShowModalForScheduleFollowUp={setShowModalForScheduleFollowUp}
            showModalForScheduleFollowUp={showModalForScheduleFollowUp}
            appointment={appointment}
            followUpData={followUpData}
            setOpenAlert={setOpenAlert}
            setAlertMsg={setAlertMsg}
            appointmentsApi={appointmentsApi}
          />
        )}

        {showPhysicalConsultationModal && (
          <PhysicalConsultationModal
            appointmentType={appointment?.appointment_type}
            // appointmentId={appointment.appointment_id}
            doctor_slug={""}
            closeView={() => {
              setShowPhysicalConsultationModal(false);
            }}
            openView={showPhysicalConsultationModal}
            isAddMode={false}
            step={1}
            // doctorData={doctorData}
            callNextAppointmentWidget={props?.callNextAppointmentWidget}
            addBooking={true}
            existingOrderId={appointment?.order_id}
            appointmentData={appointment}
            handleSetAppointmentType={showSetAppointmentType}
          />
        )}
      </>
    );
  };

  // <===

  return (
    <div className="appointments-view-table-cell" ref={rowRef}>
      {receiptLoader && <ReceiptLoader />}
      {displayData()}
      {displayRestOfTheComponents()}
      {showAlertPopup && <AlertMsgPopup alertMsg={alertMsgPop} />}
    </div>
  );
};

export default AppointmentsViewTableCell;
